'use strict';

const Backbone = require('backbone/backbone');
const Events = require('constants/Events');
const ViewportEvents = require('constants/ViewportEvents');
// const Constants = require('constants/Constants');
const _ = require('underscore/underscore');
const scrollLock = require('scroll-lock');
// const svg4everybody = require('svg4everybody');
require('core-js/features/object/values');
require('core-js/features/object/entries');
require('core-js/features/array/find');
require('core-js/web/url-search-params');
require('core-js/features/promise');

const translations = {
    'en-en': require('./translated/en-en.json')
};

require('style.less');
const Router = require('./Router');
const Utils = require('utils/Utils.js');
const $ = require('jquery');
const objectFitImages = require('object-fit-images');
// const FontFaceObserver = require('fontfaceobserver');

//GolyshevAG закомментил, потому что в IE9-11 вместо того чтобы делать все хорошо,
//делает все плохо и все use внутри svg просто выпилпвает
//для случая когда свг с символами уже встроен в дум svg4everybody не только не нужен, но и вреден
// svg4everybody();

const MobileDetect = require('mobile-detect');

const TopNav = require('components/Common/TopNav/TopNav');

const promisePolyfill = require('promise-polyfill');

if (!window.Promise) {
    window.Promise = promisePolyfill;
}

const mobileDetect = new MobileDetect(window.navigator.userAgent);
const phone = mobileDetect.phone();
const tablet = mobileDetect.tablet();

window.app.settings.isDesktop = !phone && !tablet;
window.app.settings.isMobile = phone || tablet;
window.app.settings.isTablet = !!tablet;
window.app.settings.isPhone = !!phone;

document.documentElement.className += ' ' + (app.settings.isDesktop ? 'isDesktop' : 'isNotDesktop');
document.documentElement.className += ' ' + (!app.settings.isDesktop ? 'isMobile' : 'isNotMobile');
document.documentElement.className += ' ' + (app.settings.isTablet ? 'isTablet' : 'isNotTablet');
document.documentElement.className += ' ' + (app.settings.isPhone ? 'isPhone' : 'isNotPhone');


// const unica600 = new FontFaceObserver('neue-haas-unica', {
//     weight: 600,
//     style: 'normal'
// });
//
// const unica400 = new FontFaceObserver('neue-haas-unica', {
//     weight: 400,
//     style: 'normal'
// });

window.app.commonSelectors = {
    body: 'body',
    html: 'html',
    htmlBody: 'html,body',
    topNav: '.TopNav',
    popupContainer: '.Page-popup',
    popupWrapper: '.Popup-wrapper'
};

// Promise.all([unica600.load(), unica400.load()])
//     .then(function () {
//         // console.log('Fonts loaded');
//         window.app.state.fontsLoaded = true;
//         window.app.vent.trigger(Events.common.fontsLoaded);
//
//         force recalcs of texts dims for dotdotdot plugin and other code
//         const resizeEvent = window.document.createEvent('UIEvents');
//         resizeEvent.initUIEvent(ViewportEvents.resize, true, false, window, 0);
//         window.dispatchEvent(resizeEvent);
//     }, function () {
//         // console.log('Fonts is not available');
//     });


window.app.isPhoneLayout = function () {
    return window.matchMedia('(max-width: 767px)').matches;
};


(function () {
    var elem = document.createElement('canvas');

    if (!!(elem.getContext && elem.getContext('2d'))) {
        // was able or not to get WebP representation
        app.settings.isWebp = elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    } else {
        app.settings.isWebp = false;
    }
})();


// $.get(window.app.settings.staticUrl + 'svg/symbol/svg/sprite.symbol.svg', function (data) {
// $.get('/static/svg/symbol/svg/sprite.symbol.svg', function (data) {
//     var div = document.createElement('div');
//     div.style.display = 'none';
//     div.innerHTML = new XMLSerializer().serializeToString(data.documentElement);
//     document.body.insertBefore(div, document.body.childNodes[0]);
// });

// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
// MIT license
(function () {
    let lastTime = 0;
    const vendors = ['ms', 'moz', 'webkit', 'o'];
    for (let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame']
            || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function (callback) {
            const currTime = new Date().getTime();
            const timeToCall = Math.max(0, 16 - (currTime - lastTime));
            const id = window.setTimeout(function () {
                callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;

            return id;
        };
    }

    if (!window.cancelAnimationFrame) {
        window.cancelAnimationFrame = function (id) {
            clearTimeout(id);
        };
    }

    if (window.app.settings.isMobile) {
        const FastClick = require('fastclick');
        FastClick.attach(document.body);
    }
})();


window.app.state = {
    countOfOpenedPopups: 0
};
window.app.vent = _.extend({}, Backbone.Events);
window.app.utils = Utils;

// eslint-disable-next-line complexity
window.gettext = function (key, text, args) {
    const lang = window.app.settings.lang || 'en-en';
    let str = '';
    if (translations && translations[lang]) {
        str = ([lang] || translations['en-en'])[key] || text;
    }

    for (let k in args) {
        if (args.hasOwnProperty(k)) {
            str = str.replace('\$\{' + k + '\}', args[k]);
        }
    }

    // return (translations[window.app.settings.lang || 'en-en'] || translations['en-en'])[key] || text;
    return str;
};

window.app.els = {
    $window: $(window),
    $body: $(window.app.commonSelectors.body),
    $html: $(window.app.commonSelectors.html),
    $htmlBody: $(window.app.commonSelectors.htmlBody),
    $topNav: $(window.app.commonSelectors.topNav),
    $popupContainer: $(window.app.commonSelectors.popupContainer)
};

window.app.sizes = {};

//should be first, cause topNav listen topNavPopup events
window.app.views = {};

if (window.app.els.$topNav.length) {
    window.app.views.topNav = new TopNav({
        el: window.app.els.$topNav
    });
}

if (app.settings.isIE) {
    objectFitImages();
}

window.app.router = new Router();

app.els.$window
    .on(ViewportEvents.scroll, function () {
        window.app.vent.trigger(Events.common.scroll, app.els.$window.scrollTop());
    })
    .on(ViewportEvents.resize, function () {
        const windowWidth = window.app.els.$window.width();
        const windowHeight = window.app.els.$window.height();

        //usefull for mobile scroll, when bottom nav panel hides/reveals on up/down scroll
        //causing resize event, which is very harmhull for us
        if (windowWidth === window.app.sizes.windowWidth && windowHeight === window.app.sizes.windowHeight) {
            return;
        }

        window.app.sizes.windowWidth = windowWidth;
        window.app.sizes.windowHeight = windowHeight;

        window.app.vent.trigger(Events.common.resize);
    });

//proceed any popup show/hide
//set all underlying content fixed position
app.vent.on(Events.popup.popupShown, function () {
    app.vent.trigger(Events.landings.detachEvents);
    const htmlOverflow = window.app.isPhoneLayout() ? 'hidden' : '';
    window.app.els.$html.css('overflow', htmlOverflow);
    scrollLock.setFillGapMethod('max-width');
    scrollLock.disablePageScroll();

    app.state.countOfOpenedPopups++;
    app.state.popupShown = true;
}.bind(this));

app.vent.on(Events.popup.popupHidden, function () {
    scrollLock.enablePageScroll();
    window.app.els.$html.css('overflow', '');
    app.state.countOfOpenedPopups--;
    app.state.popupShown = false;
}.bind(this));

const events = [
    {
        name: Events.home.hero.cardLoaded,
        callback: () => {
        }
    },
    {
        name: Events.home.hero.videoSequenceLoaded
    }
];

app.utils.waitForEvents(events, () => {
    // force recalcs of texts dims for dotdotdot plugin and other code
    const resizeEvent = window.document.createEvent('UIEvents');
    resizeEvent.initUIEvent(ViewportEvents.resize, true, false, window, 0);
    window.dispatchEvent(resizeEvent);

    app.vent.trigger(Events.common.pageLoaded);
});

app.utils.initGsap();

app.utils.detectVideoAutoplayFeature(function (res) {
    app.settings.hasAutoPlay = res;
    window.app.router.start();
});

// require('mq-genie');

